// Срок действия кабинета корпоративного клиента.
// Единственное место, которое знает поля бэка active_until / activity_status.
// Статус определяет сервер (в UTC): часы браузера и расчёт от last_buffer_replenishment_date не используем.
//
// active   — обычный кабинет, дата берётся из active_until;
// expired  — ограниченный кабинет (каталог, корзина, свои заказы), нужна покупка продления;
// unknown  — срок не определён (неполная история или новый корп): доступ обычный, дату не выдумываем.
import moment from 'moment';

export const ACTIVITY_STATUSES = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  UNKNOWN: 'unknown',
};

// Что доступно корпу с истёкшим сроком: экран срока, каталог, корзина, свои заказы, поддержка
export const CORP_EXPIRED_ROUTES = [
  'profile', 'list-services', 'serviceDetail', 'reportSample', 'basket', 'my-orders', 'support', 'noaccess', '404',
];

// Код ответа 403, по которому узнаём истёкший кабинет (текст сообщения не анализируем)
export const EXPIRED_CODE = 'corporate_client_expired';

export const ACTIVITY_STATUS_OPTIONS = [
  { value: ACTIVITY_STATUSES.ACTIVE, text: 'Активен' },
  { value: ACTIVITY_STATUSES.EXPIRED, text: 'Срок истёк' },
  { value: ACTIVITY_STATUSES.UNKNOWN, text: 'Срок не определён' },
];

const COLORS = {
  [ACTIVITY_STATUSES.ACTIVE]: 'success',
  [ACTIVITY_STATUSES.EXPIRED]: 'error',
  [ACTIVITY_STATUSES.UNKNOWN]: 'grey',
};

const hasActivityFields = (o) => !!o && typeof o === 'object' && ('activity_status' in o || 'active_until' in o);

// Поля срока в объекте корпа или в get-me: на верхнем уровне либо в объекте самого корпа.
// Чужие вложенные объекты (менеджер, партнёр) не просматриваем: их срок нельзя выдать за срок корпа.
export function findActivitySource(src) {
  if (!src || typeof src !== 'object') return null;
  if (hasActivityFields(src)) return src;
  return ['corp_client', 'corpclient'].map((key) => src[key]).find(hasActivityFields) || null;
}

/**
 * Объект корпа или get-me → модель срока кабинета.
 * Возвращает null, если бэк не прислал полей срока: тогда ничего не показываем.
 */
export function parseCorpActivity(src) {
  const raw = findActivitySource(src);
  if (!raw) return null;
  const known = Object.values(ACTIVITY_STATUSES);
  const status = known.includes(raw.activity_status) ? raw.activity_status : ACTIVITY_STATUSES.UNKNOWN;
  // active_until — дата без времени и часового пояса
  const date = raw.active_until ? moment(raw.active_until, 'YYYY-MM-DD', true) : null;
  const until = date && date.isValid() ? date.format('YYYY-MM-DD') : null;
  const untilText = until ? date.format('DD.MM.YYYY') : '';

  let label = 'Срок не определён';
  if (status === ACTIVITY_STATUSES.ACTIVE) label = untilText ? `Активен до ${untilText}` : 'Активен';
  if (status === ACTIVITY_STATUSES.EXPIRED) label = untilText ? `Срок истёк ${untilText}` : 'Срок истёк';

  return {
    status,
    until,
    untilText,
    label,
    color: COLORS[status],
    isExpired: status === ACTIVITY_STATUSES.EXPIRED,
  };
}
